import { render, staticRenderFns } from "./ServiceVolumes.vue?vue&type=template&id=64062448&scoped=true&"
import script from "./ServiceVolumes.vue?vue&type=script&lang=js&"
export * from "./ServiceVolumes.vue?vue&type=script&lang=js&"
import style0 from "./ServiceVolumes.vue?vue&type=style&index=0&id=64062448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64062448",
  null
  
)

export default component.exports